<template>
  <md-app>
    <md-app-drawer md-permanent="full">
      <md-tabs md-alignment="centered">
        <md-tab md-label="Overview" :md-active="handbook">
          <HandbookOverview />
        </md-tab>
        <md-tab md-label="Sections" :md-active="sections">
          <HandbookSectionList />
        </md-tab>
      </md-tabs>
    </md-app-drawer>
    <md-app-content class="c-content">
      <Handbook @signed="signed" @visited="visited"/>
    </md-app-content>
  </md-app>
</template>
<script>
import HandbookOverview from '@/components/admin/HandbookOverview.vue'
import Handbook from '@/components/Handbook.vue'
import HandbookSectionList from '@/components/admin/HandbookSectionList.vue'
export default {
  name: "AdminDashboard",
  components:{
    HandbookOverview,
    Handbook,
    HandbookSectionList
  },
  methods: {
    signed: () => console.log('signed'),
    visited: () => console.log('visited')
  },
  computed: {
    handbook: function(){ return ((this.$router.params && this.$router.params.tab) || "handbook") === "handbook" },
    sections: function(){ return ((this.$router.params && this.$router.params.tab) || "handbook") === "sections" }
  }
}
</script>
<style>
.md-app {
  min-height: 100%;
}
.c-content {
  border-left: 1px solid transparent !important;
  border-left-color: rgba(0,0,0,0.12) !important;
  border-left-color: var(--md-theme-default-divider-on-background, rgba(0,0,0,0.12)) !important;
  border-right: none !important;
}
</style>
